import {
  ADICIONAR_FILTRO_FECHAMENTO_CAIXA, LIMPAR_FILTRO_FECHAMENTO_CAIXA, LISTAR_FILTROS_FECHAMENTO_CAIXA, REMOVER_FILTRO_FECHAMENTO_CAIXA
} from '../../actions/types'
import { filtroExiste } from '../../util/filtros'

const initialState = undefined

const initial = {
}

export const filtrosAdicionadosFechamentoCaixa = (state = [], action = initialState) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_FECHAMENTO_CAIXA: {
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }

    case REMOVER_FILTRO_FECHAMENTO_CAIXA: {
      const copia = [...state]
      return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
    }

    case LIMPAR_FILTRO_FECHAMENTO_CAIXA: {
      return []
    }

    default:
      return state
  }
}

export const filtrosFechamentoCaixa = (state = initial, action) => {
  switch (action.type) {
    case LISTAR_FILTROS_FECHAMENTO_CAIXA: {
      return action.payload.data
    }
    default:
      return state
  }
}
